import * as url from "../../constants/urls";
import * as act from "./actiontypes";

export const getProfileData = (from) => {
  let myUrl;
  return (dispatch, getState) => {
    const { token, type } = getState().user.user;
    const userType = type;
    if (userType === "both") {
      myUrl = url.profileDataUrlB;
    } else {
      if (from === "seeker") myUrl = url.profileDataUrl;
      else myUrl = url.profileDataUrlG;
    }
    return fetch(myUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          if (userType === "both") {
            if (from === "seeker") return json.seekerdata;
            else return json.giverdata;
          }
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const updateProfileData = (data, from) => {
  let myUrl;
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    if (key === "user") continue;
    else form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    if (from === "seeker") myUrl = url.updateProfileUrl;
    else myUrl = url.updateProfileUrlG;
    return fetch(myUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getReport = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    //  get report data
    return fetch(url.reportDataUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          const {
            career,
            control,
            emotion,
            experiences,
            gratitude,
            health,
            progress,
            relationship,
            score,
          } = json;
          dispatch({
            type: act.REPORT_DATA_SUCCESS,
            reportData: {
              career,
              control,
              emotion,
              experiences,
              gratitude,
              health,
              progress,
              relationship,
              score,
            },
          });
          return {
            career,
            control,
            emotion,
            experiences,
            gratitude,
            health,
            progress,
            relationship,
            score,
          };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getMyData = (from, tobe) => {
  return (dispatch, getState) => {
    let myUrl;
    const { token, type } = getState().user.user;
    console.log(token, type);
    const userType = type;
    if (userType === "both" || tobe === "both") {
      myUrl = url.userDataUrlB;
    } else {
      if (from === "seeker") myUrl = url.userDataUrl;
      else myUrl = url.userDataUrlG;
    }
    //  get user data
    return fetch(myUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        const {
          data,
          referals,
          referalcode,
          taketest,
          ikigai,
          advertisements,
          giverstatus,
          seekerstatus,
          givernoticount,
          seekernoticount,
          isindianuser,
          aproved,
          paymentstatus,
          ecomm_status,
        } = json;
        
        if (json.success) {
          dispatch({
            type: act.USER_DATA_SUCCESS,
            user: {
              data,
              referals,
              referalcode,
              taketest,
              userType,
              ikigai,
              seekerstatus,
              isindianuser,
              aproved,
              giverstatus,
              ecomm_status,
            },
          });
          return {
            advertisements,
            seekernoticount,
            givernoticount,
            data,
            aproved,
            paymentstatus,
            ecomm_status
          };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getProgress = (from) => {
  return (dispatch, getState) => {
    let myUrl;
    const { token } = getState().user.user;
    if (from === "seeker") myUrl = url.getProgressUrl;
    else myUrl = url.getProgressUrlG;
    //  get user data
    return fetch(myUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          const { coaching, freelance, ds, therapy } = json;
          return { coaching, freelance, ds, therapy };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getPackages = (pkg) => {
  let myUrl;
  switch (pkg) {
    case "Coaching":
      myUrl = url.getCoachingPackagesUrl;
      break;
    case "Therapy":
      myUrl = url.getTherapyPackagesUrl;
      break;
    case "Digital":
      myUrl = url.getDigitalServicePackagesUrl;
      break;
    case "Freelance":
      myUrl = url.getFreelancePackagesUrl;
      break;
    default:
      break;
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(myUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          const {
            categories,
            subCategories,
            limit,
            subscriptionAmount,
            packages,
          } = json;
          return {
            categories,
            subCategories,
            limit,
            subscriptionAmount,
            packages,
          };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const submitQuestionnaire = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    if (key === "12" || key === "13")
      for (let j of data[key]) form_data.append(key, j);
    else form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.questionnaireUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getCoachingDetail = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.viewWorkshopUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getWorkshop = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.viewWorkshopUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const interestedWorkshop = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.interestedWorkshopUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getService = (service) => {
  let serviceUrl;
  switch (service) {
    case "freelance":
      serviceUrl = url.viewFreelanceUrl;
      break;
    case "therapy":
      serviceUrl = url.viewTherapyUrl;
      break;
    case "digital":
      serviceUrl = url.viewDigitalUrl;
      break;
    default:
      break;
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    //  get user data
    return fetch(serviceUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          let toReturn = {
            data: json.data,
            type: json.type,
          };
          return toReturn;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getResources = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.resourceDataUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          const { audio, video, content } = json;
          return { audio, video, content };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getNotifications = (from) => {
  let myUrl;
  if (from === "seeker") myUrl = url.getNotificationsUrl;
  else myUrl = url.getNotificationsUrlG;
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(myUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return [json.broadcast, json.data];
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getCoaching = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.viewCoachingUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getCategories = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.getCategoriesUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.categories;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getInspirations = (from) => {
  let myUrl;
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    if (from === "seeker") myUrl = url.viewAllInspirationUrl;
    else myUrl = url.viewMyInspirationUrl;
    return fetch(myUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const deleteInspiration = (data, from) => {
  let myUrl;
  if (from === "seeker") myUrl = url.deleteInspirationUrl;
  else myUrl = url.deleteInspirationUrlG;
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(myUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const editInspiration = (data, from) => {
  let myUrl;
  if (from === "seeker") myUrl = url.editInspirationUrl;
  else myUrl = url.editInspirationUrlG;
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(myUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const likeInspiration = (data, from) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.likeInspirationUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.message;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const addInspiration = (data, from) => {
  let myUrl;
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    if (from === "seeker") myUrl = url.addInspirationUrl;
    else myUrl = url.addInspirationUrlG;
    return fetch(myUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};
export const initiateEndSession = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.initiateEndSessionUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.showsummaryscreen;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const endSession = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.endSessionUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const addWorkshop = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    if (data[key] === "") continue;
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.addWorkshopUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};
export const getTransactions = (from) => {
  let myUrl;
  if (from === "seeker") myUrl = url.viewTransactionUrl;
  else myUrl = url.viewTransactionUrlG;
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(myUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          const {
            coaching,
            digitalservices,
            freelance,
            therapy,
            workshops,
          } = json;
          return { coaching, digitalservices, freelance, therapy, workshops };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const cancelPackage = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.cancelPackageUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getMyReports = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.getMyReportsUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          const { coaching, freelance, therapy, digital } = json;
          return { coaching, freelance, therapy, digital };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const giveFeedback = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.servicesFeedbackUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};
export const viewGiversFeedback = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.viewGiversFeedbackUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.summaryreport;
        } else {
          throw Error(json.message);
        }
      });
  };
};
export const giversFeedbackAction = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.giversFeedbackActionUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};
export const getIkigaiAnswers = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.getIkigaiAnswersUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          //converting to components requirement
          let answers = {};
          if (json.data)
            json.data.forEach((ans) => {
              answers["phase" + ans.phase_no + "_" + ans.question_no] =
                ans.answer;
            });
          return answers;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const submitIkigai = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.submitIkigaiUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const joinClub = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    if (data[key] === "") continue;
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.interestedClubUrl, {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getFreeCoachingAction = () => {
  return async (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.getFreeCoaching, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        // if (json.success) {
        //   return json;
        // } else {
        //   return(json);
        // }
        return json;
      });
  };
};
